import { getCarData, saveCar, removeCar, countShoppingCart } from '@/api/car.js'
import { getConsumerCondition } from '@/utils/cookies'
import { getLocalNotLgCarData } from '@/utils/localStorage'
import utils from '@/utils/utils.js'

const common = {
  state: {
    carNum: ''
  },
  mutations: {
    handleCarNum: (state, num) => {
      state.carNum += num
    },
    setCarNum: (state, num) => {
      state.carNum = num
    }
  },
  actions: {
    addCar ({ commit }, productBody) {
      return new Promise((resolve, reject) => {
        saveCar(productBody).then(response => {
          let resultData = response.data
          let errorInfo = resultData.errorInfo
          if (errorInfo === 'success') {
            if (!(utils.isNotEmpty(resultData.otherData))) {
              commit('handleCarNum', 1)
            }
          }
          resolve(resultData)
        }).catch(error => {
          reject(error)
        })
      })
    },
    removeCar ({ commit }, idArray) {
      return new Promise((resolve, reject) => {
        removeCar(idArray).then(response => {
          let resultData = response.data
          let errorInfo = resultData.errorInfo
          if (errorInfo === 'success') {
            commit('handleCarNum', -idArray.length)
          }
          resolve(resultData)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getCarNum ({ commit }, params) {
      return new Promise((resolve, reject) => {
        let lgToken = getConsumerCondition()
        if (utils.isNotEmpty(lgToken)) { // 登录
          if (!(utils.isNotEmpty(params))) {
            params = {
              cpage: 1,
              pageSize: 10
            }
          }
          countShoppingCart({}).then(response => {
            console.log(response.data.data.count)
            let resultData = response.data
            let errorInfo = resultData.errorInfo
            if (errorInfo === 'success') {
              commit('setCarNum', resultData.data.count)
              // getCarData(params).then(res => {
              //   if(res.data.errorInfo === 'success'){
              //     resolve(res.data.data)
              //   }
              // })
            } else {
              resolve(null)
            }
          }).catch(error => {
            reject(error)
          })
        } else {
          let localCarList = getLocalNotLgCarData()
          if (utils.isNotEmpty(localCarList)) {
            let returnData = {
              list: localCarList
            }
            resolve(returnData)
            commit('setCarNum', localCarList.length)
          } else {
            resolve(null)
            commit('setCarNum', 0)
          }
        }
      })
    }
  }
}

export default common



// WEBPACK FOOTER //
// ./src/store/modules/car.js